module.exports = __webpack_public_path__ + "img/skill-6.4b5ffae6.svg";